
import VolumeCross from "../../../assets/filled/VolumeCross.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VolumeCrossIcon({ className, dataTestid = "VolumeCrossIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VolumeCross data-testid={dataTestid} className={classes} {...rest} />
  );
}
